<template>
    <div class="relative inline-flex">
        <Menu>
            <MenuButton
                class="inline-flex items-center p-2"
                :class="[
                    $store.getters.scope === 'preorder'
                        ? 'text-zinc-800 hover:text-zinc-600'
                        : 'text-zinc-400 hover:text-zinc-500',
                ]"
            >
                <globe-icon class="h-4 w-4" />
                <span class="hidden ml-1 md:inline-flex">{{ __("Język") }}</span>
            </MenuButton>

            <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
            >
                <MenuItems
                    class="origin-top-right absolute top-full right-0 w-32 rounded-md shadow-2xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                >
                    <div class="p-5 space-y-3">
                        <MenuItem v-for="language in languages" :key="language.code">
                            <button
                                class="flex space-x-2"
                                :class="{ 'font-bold': $store.getters.locale === language.code }"
                                @click="setLocale(language.code)"
                            >
                                <span>{{ __(language.label) }}</span>
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </transition>
        </Menu>
    </div>
</template>

<script>
import { GlobeIcon } from "@heroicons/vue/solid";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";

export default {
    name: "SectionHeaderLocale",
    components: {
        Menu,
        MenuButton,
        MenuItems,
        MenuItem,
        GlobeIcon,
    },

    data() {
        return {
            languages: [
                { code: "pl", label: "Polski" },
                { code: "en", label: "English" },
                { code: "sk", label: "Slowacki" },
                { code: "cz", label: "Czeski" },
            ],
        };
    },

    methods: {
        setLocale(locale) {
            this.$api
                .post("/locale", {
                    locale: locale,
                })
                .then((data) => {
                    if (data.locale !== this.$store.getters.locale) {
                        this.$emitter.emit("localeUpdated", { locale: data.locale });
                    }
                });
        },
    },
};
</script>
